import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

interface StatusCaja {
    NombreSucursal: string;
    NombreRuta: string;
    NombreCamionAsignado: string;
}

interface Entity {
    nombreCaja: string;
    status: StatusCaja;
}

class CajaInfoComponent extends React.PureComponent<{ value: Entity }> {
    render() {
        const {   status } = this.props.value;
        return (
            <div>
                <kea.Panel title="Status de la caja en el momento de inicio del proceso">
                    {kea.autogrid(3, [
                        <kea.Text value={this.props.value.nombreCaja} label="Caja" readonly />,
                        status != null && <kea.Text value={status.NombreSucursal} label="Sucursal" readonly />,
                        status != null && <kea.Text value={status.NombreRuta} label="Ruta" readonly />,
                        status != null && <kea.Text value={status.NombreCamionAsignado} label="Camión asignado" readonly />,
                    ])}
                </kea.Panel>
            </div>
        )
    }
}

const CajaInfoRx = componentToRx(CajaInfoComponent);

export interface Props {
    value: models.CargaDescargaCajaRutaDto;
}
/**Muestra información de la caja dado el IdCaja */
export class CajaInfo extends React.PureComponent<Props> {
    render() {
        const value = {
            nombreCaja: this.props.value.NombreCaja,
            status:  this.props.value
        };
        return <CajaInfoRx value={value} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/cajainfo.tsx